import {Breadcrumb, Tabs} from 'src/feature/bite/component'

import {
  EmailEngagement,
  MemberDetailConsents,
  MemberDetailOverview,
  MemberDetailTransactions,
} from '../component/Detail'

import {useIntl} from 'react-intl'
import {useGetDetail, useGetTabDetail} from '../context/useQuery'
import {useMember} from '../hook'
import {useState} from 'react'
import {useNavigate, useSearchParams} from 'react-router-dom'

export default function MemberDetail() {
  const intl = useIntl()
  const navigate = useNavigate()
  const [searchParams] = useSearchParams()

  const getuserIDParam = () => {
    const path = window.location.pathname
    const pathParts = path.split('/')
    const userID = pathParts[pathParts.length - 1]
    return userID
  }

  const {isLoading: isLoadingTab} = useGetTabDetail(getuserIDParam())
  const {tabName, tabNameSet, detail} = useMember()
  const {isLoading} = useGetDetail(getuserIDParam())
  const [search, setSearch] = useState('')

  const tabs = [
    {
      label: intl.formatMessage({id: 'MEMBER.DETAIL.OVERVIEW'}),
      key: 'Overview',
      component: <MemberDetailOverview />,
    },
    {
      label: intl.formatMessage({id: 'MEMBER.DETAIL.CONSENTS'}),
      key: 'Consent',
      component: <MemberDetailConsents />,
    },
    {
      label: intl.formatMessage({id: 'MEMBER.DETAIL.TRANSACTIONS'}),
      key: 'Transaction',
      component: (
        <MemberDetailTransactions loading={isLoadingTab} search={search} setSearch={setSearch} />
      ),
    },
    {
      label: intl.formatMessage({id: 'MEMBER.DETAIL.EMAIL_ENGAGEMENT'}),
      key: 'EmailEngagement',
      component: <EmailEngagement loading={isLoadingTab} />,
    },
    // {
    //   label: intl.formatMessage({id: 'MEMBER.DETAIL.SMS_ENGAGEMENT'}),
    //   key: 'SmsEngagement',
    //   component: <SmsEngagement loading={isLoadingTab} />,
    // },
  ]

  function findSelectedTab(tabs: any[], selectedTab: string) {
    for (const tab of tabs) {
      if (tab.key === selectedTab) {
        return tab
      } else if (tab.childs) {
        const selectedChildTab = findSelectedTab(tab.childs, selectedTab)
        if (selectedChildTab) {
          return selectedChildTab
        }
      }
    }
    return null
  }

  return (
    <>
      <div className='d-flex flex-column-fluid gap-3 align-items-center'>
        <button
          className='btn btn-sm btn-primary btn-back'
          onClick={() => navigate('/members', {replace: true})}
        >
          <i className='fa fa-arrow-left'></i>
        </button>
        <Breadcrumb
          parentPage={intl.formatMessage({id: 'MEMBER_PLURAL'})}
          currentPage={intl.formatMessage({id: 'MEMBER.DETAIL'})}
        />
      </div>

      <div className='card mb-5 mb-xl-10 mt-10'>
        <div className='card-body pt-9 pb-0'>
          <div className='d-flex flex-wrap flex-sm-nowrap'>
            <div className='flex-grow-1'>
              <div className='d-flex justify-content-between align-items-start flex-wrap mb-2'>
                <div className='d-flex flex-column'>
                  <div className='page-title d-flex justify-content-center gap-5 me-3 align-items-center'>
                    <h1 className='page-heading d-flex flex-column justify-content-center text-dark fw-bold fs-3 m-0'>
                      {detail && detail.name && detail.surname
                        ? `${detail.name} ${detail.surname}`
                        : ''}
                    </h1>
                    {detail?.vipTier && (
                      <div
                        className='d-flex align-items-center gap-2 badge-success-badge py-2 px-5 rounded'
                        style={{
                          backgroundColor: '#ff6933',
                        }}
                      >
                        <span>
                          <i className='fa-solid fa-crown fs-4 text-white'>
                            <span className='path1'></span>
                            <span className='path2'></span>
                            <span className='path3'></span>
                          </i>
                        </span>
                        <span className='fs-5 text-white'>{detail?.vipTier}</span>
                      </div>
                    )}
                  </div>
                </div>
              </div>
            </div>
          </div>

          <Tabs tabs={tabs} selectedTab={tabName} setSelectedTab={tabNameSet} loading={isLoading} />
        </div>
      </div>

      <div className='tab-content' id='myTabContent'>
        <div className='tab-pane fade active show' role='tabpanel'>
          <div className='card-body pt-0'>
            <div className='tab-content' id='myTabContent'>
              {findSelectedTab(tabs, tabName)?.component}
            </div>
          </div>
        </div>
      </div>
    </>
  )
}
